import script from "./CompanyServiceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyServiceListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyServiceListView.vue?vue&type=style&index=0&id=59bcadc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bcadc8"]])

export default __exports__